import React from 'react';
import icLogo from "../assets/logos/logo192.png";

const Header = () => {
    return (
        <header className='header py2 '>
            <div className='wrapper'>
                <img alt="logo" style={{height:"30px",width:"30px"}} className='of-contain' src={icLogo}></img>
            </div>
        </header>
    );
};

export default Header;